var OrganizationState;

import Vue from 'vue';

export default OrganizationState = Vue.observable({
  name: ''
});
